<template>
  <div class="results-list">
    <GoBack currentScreen="list"/>
    <ResultsViews currentView="list" @gallery="goToColorWall" @list="goToColorList" />
    <div class="results-list__start-again">Not right? <a v-on:click="startAgain()"><b></b> Start again </a></div>
    <div class="results-list__content">
      <div v-for="(item) in resultsList" 
          v-bind:class="['results-list__item', lightOrDark('rgb('+ item.red + ',' + item.green + ',' + item.blue + ')') ? 'dark' : 'light']"
          v-bind:style="{'backgroundColor': 'rgb('+ item.red + ',' + item.green + ',' + item.blue + ')'}"
          v-on:click="showResult(item)"
          :key="item.colourName + item.id">
            <span class="popular-message" v-if="item.popular">
              Most popular choice
            </span>
          <p :inner-html.prop="item.colourName | colourTitleHtml"></p>
          <p>{{item.id}}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { event } from 'vue-analytics'
import ResultsViews from './elements/results/ResultsViews'
import GoBack from './elements/GoBack.vue'
import {lightOrDark} from '../assets/data/lightOrDark'

export default {
  name: 'ResultsList',
  components: {ResultsViews, GoBack},

  data() {
    return {
      selectedColor: this.$store.state.selectedColor,
      resultsList: this.$store.state.resultsList,
      lightOrDark: lightOrDark
    }
  },
  computed: {
    resultsListPrimaryColor() {
      return this.$store.state.resultsListPrimaryColor
    }
  },
  created() {
    if (!this.resultsList || this.resultsList.length == 0) {
      this.$router.push('/')
    }
  },
  mounted() {
    if (this.resultsListPrimaryColor) {
      this.$store.commit('updateBg', [this.resultsListPrimaryColor.red, this.resultsListPrimaryColor.green, this.resultsListPrimaryColor.blue])
    }

    var popElem = this.$el.querySelector('.popular-message');
    setTimeout(function() {
      popElem.classList.add('enter');
    }, 500)
  },
  methods: {
    startAgain() {
      event('start_again', 'Click')
      this.$store.commit('resetState')
      this.$router.push('/')
    },
    showResult(item) {
      this.$store.commit('updateSelectedColor', item)
      this.$store.commit('isListOrGridView', 'list')
      this.$router.push('/results')
    },
    goToColorWall() {
      this.$router.push({ name: 'resultsGallery', params: { primaryColor: this.resultsListPrimaryColor, colors: this.resultsList }})
    },
    goToColorList() {
      return;
    },
  }
}
</script>
